import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_DARK,
  SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_LIGHT,
} from '@oneaudi/unified-web-common';

import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';
import { CustomTheme } from './FeatureAppTypes';

const colorsLight = {
  colorCanvas200: SYS_COLOR_CANVAS_200_DARK,
  sysColorSurfaceNeutral: SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_LIGHT,
};

const colorsDark = {
  colorCanvas200: SYS_COLOR_CANVAS_200_DARK,
  sysColorSurfaceNeutral: SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_DARK,
};

const breakpoints = {
  s: parseInt(SYS_BREAKPOINT_SM, 10),
  m: parseInt(SYS_BREAKPOINT_MD, 10),
  l: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors: colorsLight,
  invertedColors: colorsDark,
  breakpoints,
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  colors: colorsDark,
  invertedColors: colorsLight,
  breakpoints,
};
